import { computed, defineComponent, reactive, } from 'vue';
import { useI18n } from 'vue-i18n';
import jungfrauLogo from '@/assets/brands/jungfrau.svg';
import lucerneLogo from '@/assets/brands/lucerne.svg';
import taksidiLogo from '@/assets/brands/taksidi.png';
// Visuals paired with i18n.brands.items by index.
const VISUALS = [
    { logo: jungfrauLogo }, //   0  Jungfrau Region
    { logo: taksidiLogo }, //    1  Taksidi
    { slug: 'canon' }, //        2  Canon
    { logo: lucerneLogo }, //    3  Lucerne Tourism
    { logo: 'https://upload.wikimedia.org/wikipedia/commons/9/9e/Bergbahnen_Engelberg-Tr%C3%BCbsee-Titlis_logo.svg' }, // 4  Titlis
    { logo: 'https://upload.wikimedia.org/wikipedia/commons/7/7e/Jungfraubahnen_Logo.svg' }, // 5  Grindelwald First (parent group)
    { logo: 'https://upload.wikimedia.org/wikipedia/commons/2/2d/Logo_Jungfraujoch.jpg' }, // 6  Jungfraujoch
    { logo: 'https://www.eigerlodge.ch/wp-content/uploads/2020/06/logo_eigerlodge.svg' }, // 7  Eiger Lodge
    { logo: 'https://adelboden-lenk-kandersteg.ch/fileadmin/TALK/TALK-Logo.svg' }, // 8  Adelboden-Lenk-Kandersteg
    { logo: 'https://upload.wikimedia.org/wikipedia/commons/7/74/Zentralbahn_logo.svg' }, // 9  Zentralbahn
    { logo: 'https://www.lakelucerne.ch/_assets/cb8d2156fdf1434daf1f943e4cc07488/Images/mainlogo.svg' }, // 10 Lake Lucerne
    {}, //                       11 Tara Style (inline SVG only — text fallback)
    { logo: 'https://www.dilmahtea.com/wp-content/themes/dilmah/img/logo.png' }, // 12 Dilmah
    { logo: 'https://www.everestoutdoor.com/cdn/shop/files/everest-logo-black.svg?v=1746099374' }, // 13 Everest Outdoor
    { logo: 'https://upload.wikimedia.org/wikipedia/commons/5/52/EMU_Logo_Lock_Up_DRK_BLU.png' }, // 14 Emu Australia
    { logo: 'https://upload.wikimedia.org/wikipedia/commons/5/57/Krups_Logo.svg' }, // 15 Krups
];
export default defineComponent({
    name: 'Brands',
    setup() {
        const { tm } = useI18n();
        const brands = computed(() => {
            const texts = tm('brands.items');
            return texts.map((t, i) => ({ ...t, ...(VISUALS[i] ?? {}) }));
        });
        // Duplicate for seamless infinite loop via translateX(-50%).
        const loop = computed(() => [...brands.value, ...brands.value]);
        // Track logos that failed to load so we fall back to the text name.
        const failedSrcs = reactive({});
        const logoSrc = (brand) => {
            if (brand.logo)
                return brand.logo;
            if (brand.slug)
                return `https://cdn.simpleicons.org/${brand.slug}`;
            return null;
        };
        const handleError = (src) => {
            if (src)
                failedSrcs[src] = true;
        };
        const hasWorkingImage = (brand) => {
            const src = logoSrc(brand);
            return src !== null && !failedSrcs[src];
        };
        return {
            loop,
            logoSrc,
            handleError,
            hasWorkingImage,
        };
    },
});
